var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":_vm.icon,"loading":_vm.loading,"text":""},on:{"click":_vm.download}},[_c('v-icon',{attrs:{"left":!_vm.icon,"color":_vm.error ? 'error' : _vm.color}},[_vm._v("file_download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }